import { __decorate, __metadata } from "tslib";
import { Component, Input } from 'angular-ts-decorators';
import template from './product-item-sku.component.html';
var ProductItemSkuComponent = (function () {
    function ProductItemSkuComponent() {
    }
    ProductItemSkuComponent.$inject = [];
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], ProductItemSkuComponent.prototype, "sku", void 0);
    ProductItemSkuComponent = __decorate([
        Component({
            selector: 'productItemSku',
            template: template,
        })
    ], ProductItemSkuComponent);
    return ProductItemSkuComponent;
}());
export { ProductItemSkuComponent };
